import { useCallback } from 'react';

import { useSharedStateSelector } from '@trello/shared-state';

import { boardSwitcherSharedState } from './boardSwitcherSharedState';

export const useBoardSwitcherLayout = () => {
  const layout = useSharedStateSelector(
    boardSwitcherSharedState,
    useCallback((state) => state.layout, []),
  );

  return layout;
};
